import { useEffect } from 'react';
import { StyleSheet, Dimensions, Platform } from 'react-native';
import { NativeStackScreenProps } from '@react-navigation/native-stack';
import { PrivateStackParamList } from '../../../navigationApp/types';
import ScreenWrapper from "@hoc/ScreenWrapper";
import { ThemedText, ThemedView } from "@app/theme";
import SuccessBlue from "@app/assets/svg/SuccessBlue";
import { addCommasToNumber } from "@app/utils";
import LottieView from "lottie-react-native";
import FetchSuccessImage from "@app/assets/svg/FetchSuccessImage";
import { isMobileView } from "@sharedComponents/stack/utils";
import { useIsEnhanceLimit } from '@app/hooks/useIsEnhanceLimit';

export type MFCentralLandingScreenProps = NativeStackScreenProps<PrivateStackParamList, 'MFC_FETCH_LANDING'>;

const MFCentralLanding = ({ navigation, route }: MFCentralLandingScreenProps) => {
    const screenHeight = Dimensions.get('window').height;

    const { isFromEnhanceLimit } = useIsEnhanceLimit()

    useEffect(() => {
        setTimeout(() => {
            if(Platform.OS === 'web') { 
                navigation.navigate("MFC_FETCH_ANCHOR")
            }
             else {
                navigation.reset({
                    index: 0,
                    routes: [{ name: 'HOME' }, { name: 'MFC_FETCH_ANCHOR'}],
                })
             }
        }, 3000)
    }, []);


    return (
        <ScreenWrapper screenName={route?.name} additionalProperties={{ newArchRoute: true }}>
            <ThemedView backgroundColor="bg-surface-primary" flex={1} justifyContent={"center"}>

                <>
                    <ThemedView style={{ position: 'absolute', width: '100%', top: 40 }}>
                        <FetchSuccessImage height={""} />
                    </ThemedView>
                    <ThemedView style={{ position: 'absolute', width: "100%", height: "100%", alignItems: "center", justifyContent: "center", zIndex: 99 }}>
                        <LottieView source={require("../../../assets/lottie/fall-from-the-sky.json")} autoPlay={true} loop={true} />
                    </ThemedView>
                    <ThemedView
                        justifyContent={"center"}
                        alignSelf={"center"}
                        borderRadius={"xl"}
                        style={{
                            position: 'absolute',
                            top: !isMobileView() && screenHeight >= 700 ? '25%' : '20%',
                            zIndex: 2,
                            padding: 24,
                            width: "80%",
                            shadowColor: '#000',
                            shadowOpacity: 0.08,
                            shadowRadius: 16,
                            shadowOffset: { width: 0, height: 4 },
                            elevation: 8,
                        }}
                        borderColor={"border-primary"}
                        // backgroundColor={"white"}
                        backgroundColor='bg-fill-primary'
                    >
                        <ThemedView alignSelf={"center"} mb={"5xl"}>
                            <SuccessBlue />
                        </ThemedView>
                        <ThemedText variant={"h2b"} textAlign={"center"} mb={"xs"}>
                            Congratulations!
                        </ThemedText>
                        <ThemedText variant={"b2r"} textAlign={"center"}>
                            {
                                isFromEnhanceLimit
                                    ? 'You are eligible for an additional limit of'
                                    : 'Your eligible limit is'
                            }
                        </ThemedText>
                        <ThemedView flexDirection={"row"} alignItems={"center"} mt={"sm"} justifyContent={"center"}>
                            <ThemedText variant={"l1"} color={"text-emphasis-secondary"}  >
                                ₹
                            </ThemedText>
                            <ThemedText variant={"h1b"} color={"text-emphasis-secondary"} textAlign={"center"}>
                                {route.params.availableCreditAmount !== null
                                    ? `${addCommasToNumber(Number(route.params.availableCreditAmount))}`
                                    : ""}
                            </ThemedText>
                        </ThemedView>

                    </ThemedView>
                </>
            </ThemedView>
        </ScreenWrapper>
    );
};

export default MFCentralLanding;

const styles = StyleSheet.create({
    loaderContainer: {
        flex: 1,
        justifyContent: 'center',
        alignItems: 'center',
    },
});